import React from 'react'
import withStyles from 'isomorphic-style-loader/withStyles'
import SubmitButton from '../../common/forms/SubmitButton'
import { Form, Row, Col } from 'react-bootstrap'
import FieldGroup from '../../common/forms/FieldGroup'
import FieldGroupTextArea from '../../common/forms/FieldGroupTextArea'
import EmailAddressInput from '../../common/forms/EmailAddressInput'
import ContactNumberInput from '../../common/forms/ContactNumberInput'
import * as styles from './_ContactAnAdviser.scss'
import SubmitSpinner from '../../common/Spinners/SubmitSpinner'
import SuccessCheckMessage from '../../common/SuccessCheckMessage'
import PropTypes from 'prop-types';

const message = 'Submitted.'
function isSubmitted (status) {
  return status === 'SUBMITTED'
}

function isSubmitting (status) {
  return status === 'SUBMITTING'
}

function isRateLimitReached(status) {
  return status === 'LIMIT_EXCEEDED'
}

class ContactAnAdviser extends React.Component {
  constructor (props) {
    super(props)
    this.state = {
      submitting: false
    }
    this.handleSubmitClick = this.handleSubmitClick.bind(this)
  }

  handleSubmitClick () {
    if (this.state.submitting) return
    this.setState({ submitting: true })
    this.props.handleSubmit()
    setTimeout(() => {
      this.setState({ submitting: false })
    }, 8000)
  }

  render () {
    const {
      validationstate,
      setName,
      setContact,
      setEmail,
      setComment,
      submittedStatus,
      nameAndSurname,
      contactNumber,
      emailAddress,
      comment
    } = this.props

    const buttonDisabled = !(validationstate?.formIsValid ?? false) ||
      isSubmitting(submittedStatus) ||
      this.state.submitting

    return (
      <Row className={styles['root']}>
        <Col xs={12} sm={12} md={12} lg={12}>
          <section className={styles['contact-adviser-form-section']}>
            <h2>Contact adviser</h2>
            <Form.Group>
              <FieldGroup id='nameAndSurname'
                isInvalid={validationstate?.NameContainer?.isInvalid}
                label='Name and surname'
                type='text'
                required
                message={validationstate?.NameContainer?.message}
                value={nameAndSurname}
                onChange={(event) => { setName(event.target.value) }}
              />

              <ContactNumberInput id='contactNumber'
                value={contactNumber}
                required
                validation={validationstate?.NumberContainer || { isInvalid: false, message: null, valid: true }}
                setNumber={setContact}
              />

              <EmailAddressInput id='emailAddress'
                label={'Email address'}
                required
                value={emailAddress}
                validation={validationstate?.EmailContainer || { isInvalid: false, message: null, valid: true }}
                setEmail={setEmail}
              />

              <FieldGroupTextArea
                id='comment'
                isInvalid={validationstate?.CommentContainer?.isInvalid}
                label='Comments'
                as='textarea'
                rows={8}
                help={validationstate?.CommentContainer?.message}
                value={comment}
                onChange={(event) => { setComment(event.target.value) }}
              />
            </Form.Group>
            <Form.Group>
              <Row className={styles['submit-area-button-xs']}>
                <Col xs={12} className="d-block d-md-none">
                  <SubmitButton
                    buttonText='Submit'
                    isSubmitting={isSubmitting(submittedStatus) || this.state.submitting}
                    isValid={validationstate?.formIsValid}
                    onClick={this.handleSubmitClick}
                    disabled={buttonDisabled}
                  />
                </Col>
              </Row>
              <Row>
                { isSubmitting(submittedStatus) && <Col xs={12} className="d-block d-md-none"><SubmitSpinner /></Col>}
                { isSubmitted(submittedStatus) && <Col xs={12} className="d-block d-md-none"><SuccessCheckMessage message={message} />
                </Col>}
              </Row>
              <Row className={styles['submit-area-button-large']}>
                <Col className="d-none d-md-block" sm={12} md={12} lg={12}>
                  <SubmitButton
                    buttonText='Submit'
                    isSubmitting={isSubmitting(submittedStatus) || this.state.submitting}
                    isValid={validationstate?.formIsValid}
                    onClick={this.handleSubmitClick}
                    disabled={buttonDisabled}
                  />
                  { isSubmitting(submittedStatus) && <SubmitSpinner />}
                  { isSubmitted(submittedStatus) && <p><SuccessCheckMessage message="Contact request submitted." /></p>}
                  {isRateLimitReached(submittedStatus) && <p className={styles['rate-limit-message']}>⚠️Daily email rate limit reached.</p>}
                </Col>
              </Row>
            </Form.Group>
          </section>
        </Col>
      </Row>
    )
  }
}

ContactAnAdviser.defaultProps = {
  validationstate: {
    formIsValid: false,
    NameContainer: { isInvalid: false, message: null, valid: false },
    NumberContainer: { isInvalid: false, message: null, valid: false },
    EmailContainer: { isInvalid: false, message: null, valid: false },
    CommentContainer: { isInvalid: false, help: null, valid: true }
  }
}

ContactAnAdviser.propTypes = {
  validationstate: PropTypes.object,
  validateContact: PropTypes.func.isRequired,
  setName: PropTypes.func.isRequired,
  setContact: PropTypes.func.isRequired,
  setEmail: PropTypes.func.isRequired,
  setComment: PropTypes.func.isRequired,
  handleSubmit: PropTypes.func.isRequired,
  submittedStatus: PropTypes.string.isRequired,
  navigationBack: PropTypes.func.isRequired,
  nameAndSurname: PropTypes.string.isRequired,
  contactNumber: PropTypes.string.isRequired,
  emailAddress: PropTypes.string.isRequired,
  comment: PropTypes.string.isRequired
}

export default  (ContactAnAdviser)

